module.exports = __webpack_public_path__ + "static/media/menuTacoBar.4352b317.jpg";